/**
 * Représente un point sur une carte
 */
export default class MapPosition {
    constructor(json,model) {
        /**
         * Position x en pourcentage par rapport à la largeur de la carte
         */
        this.x=json.x;
        /**
         * Position y en pourcentage par rapport à la hauteur de la carte
         */
        this.y=json.y;
        /**
         * Doit-on afficher le texte à gauche?
         */
        this.left=json.left;
        /**
         * @type {PageRoyaumeModel|PageFokoModel}
         */
        this.model=model;
    }
}